import PublicTeacherScientificProjectsTable from "./PublicTeacherScientificProjectsTables";

export default PublicTeacherScientificProjectsTable